<template>
    <div class="container background-container ">
      <h5 class="text-left mt-2 mb-3 pl-3">Collections</h5>
      <div class="form-group position-relative search-container pl-3 pr-3">
        <input
          type="text"
          class="form-control search-input"
          v-model="searchText"
        />
        <i class="fa fa-search search-icon"></i>
      </div>
      <div class="collections-list pl-2 pr-0">
        <div
          v-for="collection in filteredCollections"
          :key="collection"
          class="media user-item px-0"
          :class="{ 'selected-collection': collection === selectedCollection }"
          @click="selectCollection(collection)"
        >
          <div class="media user-item px-0" :class="{ 'selected-collection': collection === selectedCollection }">
                <div class="avatar mr-3 d-flex pl-3 muted-text">
                    <i :class="getIconClass(collection)" style="font-size: 14px;"></i>
                </div>
                <div class="d-flex flex-column text-left pr-3 collection-info">
                <h6 class="mb-0">{{ collection }}</h6>
                </div>
            </div>

        </div>
      </div>
    </div>
  </template>

<script>
import { ref, computed, onMounted, watch } from 'vue'
import { collection, getDocs } from 'firebase/firestore'
import firebase from '../../../../firebase'
import getIconClass from '../../../services/getIconBasedOnCollectionID'

export default {
  props: ['routeSelectedCollection'],
  setup (props, context) {
    const searchText = ref('')
    const selectedCollection = ref(null)
    const collections = ref([])

    onMounted(async () => {
      const allCollectionsRef = collection(firebase.db, 'AllCollections')
      try {
        const querySnapshot = await getDocs(allCollectionsRef)
        collections.value = querySnapshot.docs
          .map(doc => (doc.id))
          .sort((a, b) => a.localeCompare(b))
      } catch (error) {
        console.error('Error fetching collections: ', error)
      }
    })

    watch(() => props.routeSelectedCollection, (newValue) => {
      selectedCollection.value = newValue
    })

    const filteredCollections = computed(() =>
      collections.value.filter((collection) =>
        collection.toLowerCase()
          .includes(searchText.value.toLowerCase())
      )
    )

    const selectCollection = (collection) => {
      selectedCollection.value = collection
      context.emit('collectionSelected', collection)
    }

    return {
      searchText,
      filteredCollections,
      selectedCollection,
      selectCollection,
      getIconClass

    }
  }
}
</script>

  <style scoped>
  .container {
    background-color: white;
    font-size: 0.9rem;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 7px 0 0 7px !important;

  }

  .collections-list {
    overflow-y: auto;
    overflow-x:hidden;
  }

  .search-input {
    height: 30px;
  }

  .search-icon {
    position: absolute;
    right: 25px;
    top: 50%;
    transform: translateY(-50%);
  }

  .user-item {
    cursor: pointer;
    color: grey;
    align-items: center;
    padding: 5px 0;
  }

  .user-item.selected-collection {
    color: black;
    background-color: var(--light-grey);
    border-radius: 7px;
  }

  .text-left {
    text-align: left;
  }

  .collection-info {
    flex: 1;
    min-width: 0;
    font-size: 14px;
  }
  </style>
